<div
  class="layout-wrapper"
  [ngClass]="{
    'layout-menu-slim': slimMenu,
    'layout-menu-overlay': overlayMenu,
    'layout-menu-static': staticMenu,
    'layout-menu-static-inactive': staticMenuInactive,
    'layout-menu-overlay-active': overlayMenuActive,
    'layout-menu-active': mobileMenuActive
  }"
>
  <app-layout-page-menu-top-bar
    [actionList]="actionList"
    [redirectLink]="redirectLink"
    [accountTypeIcon]="accountTypeIcon"
  ></app-layout-page-menu-top-bar>

  <div class="layout-main">
    <div class="layout-content {{ customLayoutContentClass }}" [ngClass]="{ hideMenu: hideMenuValue }">
      <div *ngIf="userData && userData?.username" class="mu-layout-menu-sidebar" id="mu-layout-menu-sidebar">
        <app-layout-page-menu-sidebar [actionList]="actionList" [helpLink]="helpLink"></app-layout-page-menu-sidebar>
      </div>
      <div class="mu-layout-content route-outlet" id="mu-layout-content">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-mu-toast [key]="'toast-layout'" [position]="toastData.position"></app-mu-toast>
    <app-mu-toast [key]="'toast-layout-viewDetail'" [position]="toastData.position" [actionList]="toastActions"></app-mu-toast>
    <app-mu-toast [key]="'toast-layout-errors'" [position]="toastData.position" [actionList]="toastActions"></app-mu-toast>
    <app-mu-toast [key]="'toast-layout-new-users'" [position]="toastData.position" [actionList]="toastActions"></app-mu-toast>
    <app-mu-toast [key]="'toast-layout-onlyDetail'" [position]="toastData.position" [actionList]="toastActions"></app-mu-toast>
  </div>

  <div class="layout-mask" *ngIf="mobileMenuActive"></div>
  <div class="layout-table-flex-paginator"></div>
  <app-location [ingressCountrySel]="countrySel"></app-location>
</div>
